/**
 * The cookie-notice answer, shared by the notice (writer) and browser
 * monitoring (reader). The native `storage` event only fires in other
 * tabs, so the notice also announces same-tab changes with a window event.
 */
export const COOKIE_CONSENT_KEY = "cookie-consent";
export const CONSENT_CHANGED_EVENT = "na:cookie-consent-changed";

export type ConsentAnswer = "accepted" | "declined";

export function announceConsentChange(): void {
  window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT));
}
